import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js'

const url = gapi + "emps";


const emps = {
  namespaced: true,
  state: {
    empsAll: [],
    nats:[],     
    jobs:[],          
    workarea:[],
    traffic:[] 
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.empsAll;
    },
    getTodoById: (state) => (id) => {
      return state.empsAll.find((todo) => todo.id == id);
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.empsAll = data;
    },

    ADD_DATA(state, data) {
      state.empsAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.empsAll.findIndex((t) => t.id === data.id);
   
      this.nats= str.state.nats.find((todo) => todo.id == data.nat_id);
      this.jobs = str.state.jobs.find((todo) => todo.id == data.job_id);
      this.workarea = str.state.workarea.find((todo) => todo.id == data.trafficFrom);
      this.traffic = str.state.traffic.find((todo) => todo.id == data.trafficTo);
      var dts = {
               id : data.id,
               Fname:data.Fname,
               Sname:data.Sname,
               Tname:data.Tname,
               Ffname:data.Ffname,
               NationalId:data.NationalId,
               nat_id:data.nat_id,
               birthdate:data.birthdate,
               Mob:data.Mob,
               Mob2:data.Mob2,
               Address:data.Address,
               job_id:data.job_id,
               Kafel:data.Kafel,
               kafelNum:data.kafelNum,
               withFamily:data.withFamily,
               accoStart:data.accoStart,
               accoEnd:data.accoEnd,
               driverLcStart:data.driverLcStart,
               driverLcEnd:data.driverLcEnd,
               bus_id:data.bus_id,
               driverContractNum:data.driverContractNum,
               trafficFrom:data.trafficFrom,
               trafficTo:data.trafficTo,
               Salary:data.Salary,
               percentage:data.percentage,
               Nname:this.nats.nName,
               job:this.jobs.job,
               areaName:this.workarea.areaName,
               ttrafficTo:this.traffic.trafficTo,
              
                     }
      if (index !== -1) {
        state.empsAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.empsAll = state.empsAll.filter((t) => data.id !== t.id);
    },
  },
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
        })
        .catch((error) => console.log(error));
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
    async updateData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then(
          commit("UPDATE_DATA", data)

        )
        .catch((error) => console.log(error));
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default emps;
